<template>
    <div v-if="!dataslearn.datas.version"> loading </div>

    <div class="plugcontainer" v-if="dataslearn.datas.version">
        <ScormPlayer :folder_url="'packages/'+$route.params.idscorm" :id="$route.params.idscorm" :start_callback="startScorm" :end_callback="endScorm" :completion_callback="completionScorm" :score_callback="scoreScorm"/>
    </div>
</template>
<script>
import { useLearnStore } from '@/stores/learn'
import { kcAuthStore } from '@/stores/kcAuth'
import ScormPlayer from '@/components/ScormPlayer'

export default {
    name: "ScormContainer",
    components: {
        ScormPlayer: ScormPlayer
    },
    data() {
        return {
            dataslearn: useLearnStore(),
            auth: kcAuthStore(),
            chrono: 0,
            parcours: null
        }
    },
    methods: {
        startScorm: function() {
            console.log("--------------------------_> startScorm")
            this.chrono = new Date().getTime();
        },
        endScorm: function() {
            console.log("--------------------------_>endScorm")
            let session_time = new Date().getTime() - (this.chrono || new Date().getTime());
            this.dataslearn.settimeParcours(this.parcours, session_time);
        },
        completionScorm: function(completions) {
            // completions : {"completion": completion,"success":success }
            console.log("--------------------------_> completionScorm", completions)
            if (completions.completion == "completed") this.dataslearn.completeParcours(this.parcours);
           
        },
        scoreScorm: function(score) {
            this.parcours.score = score;
            this.dataslearn.completeParcours(this.parcours);
            console.log("--------------------------_> scoreScorm", score)
        },
    },
    created() {
        let that = this;

        this.parcours = this.dataslearn.getParcours(this.$route.params.idparcours);

        this.dataslearn.startParcours(this.parcours);


        that.$root.showNav = false;
        that.$root.showMenu = false;

        
    },
    watch: {
        /*idparcours: function() {

            this.parcours = this.dataslearn.getParcours(this.$route.params.idparcours);
            console.log("))))))))))) ))) ))) ) )) )))", this.idparcours)
        }*/
    },
    props: ['idscorm','idparcours'],
}
</script>
<style scoped>
  .scormplayer {
    position: fixed;
    width: calc(100% - 18em);
    height: calc(100% - 5em);
    border-radius: 1em;
    overflow: hidden;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.18);
  }

  .mobile .scormplayer {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
</style>